<template>
  <v-container class="pa-0 pl-6 karte-addon">
    <!-- 運営からの特記事項 -->
    <operator-special-note :active="active" />
    <!-- ユーザの特記事項 -->
    <parents-special-note :active="active" />
    <!-- 子の特記事項 -->
    <child-special-note :active="active" />

    <!-- エジンバラ産後うつ質問票 -->
    <epds-list v-if="user.id != null" :user-id="user.id" />

    <!-- カルテ一覧 -->
    <my-karte-list
      :karte-list="karteList"
      :my-karte-list-load-state="myKarteListLoadState"
      @reload="fetchMyKarteList"
    />

    <!-- 関連するカルテ（他科・兄弟など） -->
    <sibling-karte-list
      title="関連するカルテ"
      :karte-list="siblingKarteList"
      :is-child-name-displayable="true"
      :sibling-karte-list-load-state="siblingKarteListLoadState"
      @reload="fetchSiblingKarteList"
    >
      <span class="subtitle-2">（他科・兄弟など）</span>
    </sibling-karte-list>

    <!--  日中助産師カルテ一覧  -->
    <daytime-advice-sheet-addon-list
      :daytime-advice-sheet-addon-list-load-state="daytimeAdviceSheetAddonListLoadState"
      @reload="fetchDaytimeAdviceSheetAddonList"
    />

    <!-- 関連するいつでもカルテ一覧（他科・兄弟など） -->
    <anytime-consultation-karte-list
      :title="'関連するいつでもカルテ一覧'"
      :anytime-consultations="userAnytimeConsultations"
      :is-child-name-displayable="true"
      :ac-karte-list-load-state="acKarteListLoadState"
      @reload="fetchAcKarteList"
    />
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import loadStateMixin from "../../mixins/load_state.js";
import AnytimeConsultationKarteList from "./addon/AnytimeConsultationKarteList.vue";
import EpdsList from "./addon/EpdsList.vue";
import ParentsSpecialNote from "./addon/ParentsSpecialNote.vue";
import ChildSpecialNote from "./addon/ChildSpecialNote.vue";
import SiblingKarteList from "./addon/SiblingKarteList.vue";
import DaytimeAdviceSheetAddonList from "./addon/DaytimeAdviceSheetAddonList.vue";
import OperatorSpecialNote from "./addon/OperatorSpecialNote.vue";
import MyKarteList from "./addon/MyKarteList.vue";
import { LOAD_STATES } from "../../constants/load_states";

export default {
  name: "KarteAddon",  components: {
    AnytimeConsultationKarteList,
    EpdsList,
    ParentsSpecialNote,
    ChildSpecialNote,
    SiblingKarteList,
    DaytimeAdviceSheetAddonList,
    OperatorSpecialNote,
    MyKarteList
  },
  mixins: [loadStateMixin],
  props: {
    active: Boolean,
    userId: {
      type: Number,
      required: true,
    },
    childId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data: () => ({
    cancelToken: axios.CancelToken,
    myKarteListCancelSource: null,
    siblingKarteListCancelSource: null,
    daytimeAdviceSheetCancelSource: null,
    acKarteCancelSource: null,
    myKarteListLoadState: null,
    siblingKarteListLoadState:null,
    daytimeAdviceSheetAddonListLoadState: null,
    acKarteListLoadState: null,
    myKarteListLoadedTimerId: null,
    siblingKarteListLoadedTimerId: null,
    daytimeAdviceSheetAddonListLoadedTimerId: null,
    acKarteListLoadedTimerId: null,
  }),
  computed: {
    ...mapGetters([
      "user",
      "child",
      "karteList",
      "siblingKarteList",
      "anytimeConsultations",
      "userAnytimeConsultations",
      "reservation",
      "userDaytimeAdviceSheets",
    ]),
  },
  watch: {
    $route() {
      this.clearData();
      this.fetchData();
    },
    userId: {
      handler: "findUser",
      immediate: true,
    },
    childId: {
      handler: "findChild",
      immediate: true,
    },
  },
  created() {
    this.fetchMyKarteList();
    this.fetchSiblingKarteList();
    this.fetchDaytimeAdviceSheetAddonList();
    this.fetchAcKarteList();
  },
  unmounted() {
    this.clearData();
  },
  methods: {
    ...mapActions(["updateUser", "updateChild"]),
    fetchMyKarteList() {
      this.myKarteListLoadState = LOAD_STATES.LOADING;
      if (this.myKarteListCancelSource) {
        this.myKarteListCancelSource.cancel();
      }
      this.myKarteListCancelSource = this.cancelToken.source();
      clearTimeout(this.myKarteListLoadedTimerId);
      this.myKarteListLoadedTimerId = setTimeout(() => {
        this.myKarteListLoadState = LOAD_STATES.ERROR;
      }, 30 * 1000);

      this.$store.dispatch("fetchKartes", {
        reservationId: this.$route.query.reservation_id,
        cancelToken: this.myKarteListCancelSource.token,
      }).then(() => {
        this.myKarteListLoadState = LOAD_STATES.SUCCESS;
      }).catch(() => {
        this.myKarteListLoadState = LOAD_STATES.ERROR;
      }).finally(() => {
        clearTimeout(this.myKarteListLoadedTimerId);
      });
    },
    fetchSiblingKarteList() {
      this.siblingKarteListLoadState = LOAD_STATES.LOADING;
      clearTimeout(this.siblingKarteListLoadedTimerId);
      this.siblingKarteListLoadedTimerId = setTimeout(() => {
        this.siblingKarteListLoadState = LOAD_STATES.ERROR;
      }, 30 * 1000);
      if (this.siblingKarteListCancelSource) {
        this.siblingKarteListCancelSource.cancel();
      }
      this.siblingKarteListCancelSource = this.cancelToken.source();

      this.$store.dispatch("fetchSiblingKartes", {
        reservationId: this.$route.query.reservation_id,
        cancelToken: this.siblingKarteListCancelSource.token,
      }).then(() => {
        this.siblingKarteListLoadState = LOAD_STATES.SUCCESS;
      }).catch(() => {
        this.siblingKarteListLoadState = LOAD_STATES.ERROR;
      }).finally(() => {
        clearTimeout(this.siblingKarteListLoadedTimerId);
      });
    },
    fetchDaytimeAdviceSheetAddonList() {
      this.daytimeAdviceSheetAddonListLoadState = LOAD_STATES.LOADING;
      clearTimeout(this.daytimeAdviceSheetAddonListLoadedTimerId);
      this.daytimeAdviceSheetAddonListLoadedTimerId = setTimeout(() => {
        this.daytimeAdviceSheetAddonListLoadState = LOAD_STATES.ERROR;
      }, 30 * 1000);
      if (this.daytimeAdviceSheetCancelSource) {
        this.daytimeAdviceSheetCancelSource.cancel();
      }
      this.daytimeAdviceSheetCancelSource = this.cancelToken.source();

      this.$store.dispatch("fetchUserDaytimeAdviceSheets", {
        userId: this.userId,
        cancelToken: this.daytimeAdviceSheetCancelSource.token,
      }).then(() => {
        this.daytimeAdviceSheetAddonListLoadState = LOAD_STATES.SUCCESS;
      }).catch(() => {
        this.daytimeAdviceSheetAddonListLoadState = LOAD_STATES.ERROR;
      }).finally(() => {
        clearTimeout(this.daytimeAdviceSheetAddonListLoadedTimerId);
      });
    },
    fetchAcKarteList() {
      this.acKarteListLoadState = LOAD_STATES.LOADING;
      clearTimeout(this.acKarteListLoadedTimerId);
      this.acKarteListLoadedTimerId = setTimeout(() => {
        this.acKarteListLoadState = LOAD_STATES.ERROR;
      }, 30 * 1000);
      if (this.acKarteCancelSource) {
        this.acKarteCancelSource.cancel();
      }
      this.acKarteCancelSource = this.cancelToken.source();
      this.$store.dispatch("fetchUserAnytimeConsultations", {
        userId: this.userId,
        cancelToken: this.acKarteCancelSource.token,
      }).then(() => {
        this.acKarteListLoadState = LOAD_STATES.SUCCESS;
      }).catch(() => {
        this.acKarteListLoadState = LOAD_STATES.ERROR;
      }).finally(() => {
        clearTimeout(this.acKarteListLoadedTimerId);
      });
    },
    clearData() {
      this.resetTimers();
      this.$store.dispatch("resetUser");
      this.$store.dispatch("resetChild");
      this.$store.dispatch("clearUserDaytimeAdviceSheets");
      this.$store.dispatch("clearUserAnytimeConsultations");
      this.$store.dispatch("clearKartes");
      this.$store.dispatch("clearSiblingKartes");
    },
    findUser() {
      if (this.userId != null) {
        this.$store.dispatch("findUser", {
          userId: this.userId,
        });
      }
    },
    findChild() {
      if (this.childId != null) {
        this.$store.dispatch("findChild", {
          childId: this.childId,
        });
      }
    },
    resetTimers() {
      window.clearTimeout(this.myKarteListReadedTimerId);
      window.clearTimeout(this.siblingKarteListReadedTimerId);
      window.clearTimeout(this.daytimeAdviceSheetAddonListReadedTimerId);
      window.clearTimeout(this.acKarteListReadedTimerId);
    },
  },
};
</script>
<style lang="scss" scoped>
/* override */
.v-toolbar__title {
  color: #fff;
  font-size: 14px;
}
</style>
